import React, { Component } from 'react'
import Carousel from '../../../../components/third-party/SlickCarousel'
import { Col, Hidden } from '../../../../components/atoms/Grid'
import PlaceHolder from '../../../../components/atoms/PlaceHolder'
import Avatar from '../../../../components/atoms/Avatar'
import Font from '../../../../components/atoms/Font'
import Modal from '../../../../components/atoms-v2/Modal'
import ListAthletes from '../ListAthletes'

import style from './style.css'

export default class Athletes extends Component {
    state = {
        athletes: null,
        modalActive: false
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.data) {
            this.setState({
                athletes: nextProps.data
            })
        }
    }

    render() {
        return (
            <div>
                <div style={{width: `calc(100% - 100px)`, float:'left'}}>
                    {!this.state.athletes && (
                        <Carousel color='white' centerPadding='0' itens={4} arrows={false} dots={false}>
                            <Col>
                                <PlaceHolder type='circle' style={{width: '95px', height: '95px', margin: '0 auto', float: 'none'}} />
                                <PlaceHolder type='retangle' style={{width: '100%', height: '25px', marginTop: '20px'}} />
                            </Col>
                            <Col>
                                <PlaceHolder type='circle' style={{width: '95px', height: '95px', margin: '0 auto', float: 'none'}} />
                                <PlaceHolder type='retangle' style={{width: '100%', height: '25px', marginTop: '20px'}} />
                            </Col>
                            <Col>
                                <PlaceHolder type='circle' style={{width: '95px', height: '95px', margin: '0 auto', float: 'none'}} />
                                <PlaceHolder type='retangle' style={{width: '100%', height: '25px', marginTop: '20px'}} />
                            </Col>
                            <Col>
                                <PlaceHolder type='circle' style={{width: '95px', height: '95px', margin: '0 auto', float: 'none'}} />
                                <PlaceHolder type='retangle' style={{width: '100%', height: '25px', marginTop: '20px'}} />
                            </Col>
                        </Carousel>
                    )}
                    {this.state.athletes && (    
                            this.state.athletes.result.map((athlete, key) => (
                                    <div style={{padding: '10px', width: '25%', textAlign: 'center', float: 'left'}} key={`${athlete.user_name}${athlete.inscription_id}`}>
                                        <Avatar size='95' img={athlete.user_avatar_path} />
                                        <Hidden sm><Font style={{marginTop: '10px'}}>{athlete.user_name}</Font></Hidden>
                                    </div>
                                )
                            )
                    )}
                </div>
                {this.state.athletes && this.state.athletes.total > 4 && (
                    <div onClick={() => { this.setState( state => ({
                        ...state,
                        modalActive: true
                    })) }} style={{width:'90px', float:'left', cursor: 'pointer', marginLeft: '10px'}}>
                        <span className={style.circleNum}>
                            +{this.state.athletes.total-4}
                        </span>
                    </div>            
                )}

                <Modal
                    active={this.state.modalActive}
                    style={{
                        width:'1020px',
                        padding:'30px'
                    }}
                    handleClose={() => {
                        this.setState( state => ({
                            ...state,
                            modalActive: false
                        }))
                    }}
                >
                    <ListAthletes token={this.props.token} />
                </Modal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/templates/Event/Athletes/index.js